import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import styled from "styled-components";
import Home from "./pages/Home";
import Users from "./pages/Users";
import Dashboard from "./pages/Dashboard";
import SiteDetails from "./pages/SiteDetails";
import Unauthorized from "./pages/Unauthorized";
import Sites from "./pages/Sites";
import AddSite from "./pages/AddSite";
import AppShell from "./components/AppShell";
import { Spinner } from "./components/ui";
import { useAuthCheck } from "./hooks/useAuthCheck";

const Centered = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textMuted};
  gap: 12px;
  font-size: 14px;
`;

function App() {
  const { auth } = useAuthCheck();
  const searchParams = new URLSearchParams(window.location.search);
  const errorDescription = searchParams.get("error_description");

  if (auth.isLoading) {
    return (
      <Centered>
        <Spinner /> Loading session…
      </Centered>
    );
  }
  if (errorDescription && errorDescription.includes("PreSignUp failed")) return <Unauthorized />;
  if (auth.error) {
    return <Centered>Authentication error: {auth.error.message}</Centered>;
  }

  if (!auth.isAuthenticated) {
    return (
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Home />} />
      </Routes>
    );
  }

  return (
    <AppShell>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/add" element={<AddSite />} />
        <Route path="/site/:siteId" element={<SiteDetails />} />
        <Route path="/users" element={<Users />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AppShell>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
